<template>
  <div :style="{webkitTransform:'translate3d(0,'+transform+'px,0)', 'transform':'translate3d(0,'+transform+'px,0)'}"
       @mousedown.self="onTouchstart"
       @mousemove.self="onTouchmove"
       @mouseup.self="onTouchend"
       @touchstart.self="onTouchstart"
       @touchmove.self="onTouchmove"
       @touchend.self="onTouchend"
       @touchcancel="onTouchend">
    <div class="a-picker-view-item"></div>
    <div class="a-picker-view-item"></div>
    <div class="a-picker-view-item"></div>
    <div v-for="(item, j) in range" :key="j" class="a-picker-view-item">{{ rkey ? item[rkey] : item }}</div>
    <div class="a-picker-view-item"></div>
    <div class="a-picker-view-item"></div>
    <div class="a-picker-view-item"></div>
  </div>
</template>

<script>
  const ITEM_HEIGHT = 28;
  const VIEW_HEIGHT = ITEM_HEIGHT * 7;

  const rAF = window.requestAnimationFram || function(f) {
    setTimeout(f, 16);
  };

  export default {
    props: {
      range: Array,
      value: Number,
      rkey: String,
      force: Number
    },

    data() {
      return {
        transform: 0
      };
    },

    watch: {
      $props: {
        handler() {
          this.resetState(true);
        },
        deep: true
      }
    },

    created() {
      this.__seq = 1;
      this.resetState(false);
    },

    beforeDestroy() {
      this.__seq = -1;
    },

    methods: {
      resetState(animation) {
        const len = this.range.length;
        this.__locked = len === 0; // 不处理任何事件
        this.__seq++;
        this.__top = 0;
        this.__bottom = VIEW_HEIGHT - ((len + 6) * ITEM_HEIGHT);

        if (animation) {
          this.moveToItem(-this.value, this.__seq);
        } else {
          this.transform = -this.value * ITEM_HEIGHT;
        }
      },

      onTouchstart(e) {
        e.preventDefault();
        if (!e.changedTouches) return;
        if (this.__locked) return;

        const y = e.changedTouches[0].pageY;
        const now = new Date().getTime();

        this.__rec_y = this.__start_y = y;
        this.__rec_ts = now;
        this.__speed = 0;
        this.__start_seq = this.__seq = this.__seq + 1;

        this.$emit('touchstart');
      },

      onTouchmove(e) {
        e.preventDefault();
        if (!e.changedTouches) return;
        if (this.__locked) return;
        if (this.__start_seq !== this.__seq) return;

        const y = e.changedTouches[0].pageY;
        const now = new Date().getTime();
        const delta = y - this.__rec_y;

        this.__speed = delta / (now - this.__rec_ts);
        this.__rec_y = y;
        this.__rec_ts = now;
        this.move(delta);
      },

      onTouchend(e) {
        e.preventDefault();
        if (this.__locked) return;
        if (this.__start_seq !== this.__seq) return;

        this.ease(~~(this.__speed*10), this.__seq);
      },

      move(delta) {
        let v = this.transform + delta;
        if (v > this.__top) {
          v = this.__top;
        } else if (v < this.__bottom) {
          v = this.__bottom;
        }
        this.transform = v;
        return v === this.__top || v === this.__bottom;
      },

      ease(speed, seq) {
        if (!(speed > 0 || speed < 0)) {
          const n = Math.round(this.transform / ITEM_HEIGHT);
          this.moveToItem(n, seq, () => {
            this.finish(n);
          });
          return;
        }

        rAF(() => {
          if (this.__seq !== seq)
            return;

          let dist = speed;
          if (dist > 20) {
            dist = 20;
          } else if (dist < -20) {
            dist = -20;
          }

          if (this.move(dist)) {
            speed = 0;
          }
          this.ease(~~(speed * 0.95), seq);
        });
      },

      moveToItem(n, seq, cb) {
        const y = n * ITEM_HEIGHT;

        if (this.transform === y) {
          cb && cb();
        } else {
          const fn = () => {
            if (this.__seq !== seq)
              return;

            const diff = y - this.transform;
            let step = ~~(diff / 2);
            if (Math.abs(diff) < 3) {
              step = diff;
              cb && cb(n);
            } else {
              if (step > 20) step = 20;
              else if (step < -20) step = -20;
              rAF(fn);
            }
            this.move(step);
          };
          rAF(fn);
        }
      },

      finish(n) {
        const value = Math.abs(n);

        if (value !== this.value) {
          this.$emit('change', {
            value: Math.abs(n)
          });
        }
      }
    }
  };
</script>

<style lang="scss">
  $VIEW-HEIGHT: 140px;
  $ITEM-HEIGHT: 28px;

  .a-picker-view-item {
    pointer-events: none;
    box-sizing: border-box;
    padding: 0 2px;
    width: 100%;
    height: $ITEM-HEIGHT;
    line-height: $ITEM-HEIGHT;
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/ui/base/components/picker-view-column.vue